import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Projects } from '../components/Projects';
import { Contact } from '../components/Contact';

export default function Index() {
  return (
    <div className="bg-slate-950">
      <Header />
      <Hero />
      <About />
      <Projects />
      <Contact />
    </div>
  );
}